<template>
  <div class="ProductPage">
    <div class="product-banner">
      <div class="box">
        <div class="banner-content center">
          <h1>{{ banner.title }}</h1>
          <p>{{ banner.subtitle }}</p>
          <div class="banner-features">
            <span v-for="(feature, index) in banner.features" :key="index">{{ feature.normal_text }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="product-series Pt75">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ series.title }}</h2>
          <p>{{ series.subtitle }}</p>
        </div>

        <div class="product-grid">
          <div v-for="product in featuredProducts" :key="product.id" class="product-card">
            <div class="card-image">
              <img :src="product.cover_image_path" :alt="product.name"/>
              <div class="image-overlay">
                <router-link :to="`/product_list/${product.category_id}?productId=${product.id}`" class="details-link">查看详情 →</router-link>
              </div>
            </div>
            <div class="card-content">
              <h3>{{ product.category_name }} {{ product.name }}</h3>
              <ul class="subcategory-list">
                <li v-for="(param, key, index) in product.technical_parameters" :key="index">{{ key }}: {{ param }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="recommended-cases Pt75 BgGray">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ cases.title }}</h2>
          <p>{{ cases.subtitle }}</p>
        </div>
        <div class="cases-list">
          <div v-for="(item, index) in recommendedCases" :key="index" class="case-item">
            <router-link :to="`/solutions/${item.id}`" class="case-title">
              <span class="dot">•</span> {{ item.title }}
            </router-link>
            <span class="case-date">{{ item.date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCaseScenario,
  getPageHeader,
  getProfileSection,
  getFeaturedProducts,
  getProductsCategory
} from '@/api/request.js';

export default {
  name: 'ProductPage',
  data() {
    return {
      banner: {},
      series: {},
      cases: {},
      featuredProducts: [],
      categories: [],
      recommendedCases: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const responses = await Promise.all([
          getFeaturedProducts(), // 使用新添加的 getFeaturedProducts 函数
          getCaseScenario(),
          getPageHeader({ banner_key: 'product' }),
          getProfileSection()
        ]);

        // 处理精选产品
        this.featuredProducts = responses[0].list.map(item => ({
          id: item.id,
          name: item.name,
          cover_image_path: item.cover_image_path,
          technical_parameters: item.technical_parameters || {},
          sort_order: item.sort_order,
          is_recommended: item.is_recommended,
          category_id: item.category_id,
        }));

        const categoryResponse = await getProductsCategory({ parent_id: 1});
        this.categories = (categoryResponse?.list || []).sort((a, b) => a.sort_order - b.sort_order);
        
        // 为每个featuredProduct添加category_name属性
        this.featuredProducts.forEach(product => {
          const category = this.categories.find(cat => cat.id === product.category_id);
          if (category) {
            product.category_name = category.name;
          } else {
            product.category_name = '未知分类';
          }
        });
        
        console.log('处理后的featuredProducts:', this.featuredProducts);

        // 处理推荐案例
        this.recommendedCases = responses[1].list.map(item => ({
          title: item.title,
          id: item.id,
          date: item.created_at ? item.created_at.split(' ')[0].slice(5, 10).replace('-', '/') : '未知'
        }));

        // 处理横幅
        this.banner = responses[2].list[0] || {
          title: '产品系列中心',
          subtitle: '始终专注除湿、制冷、空气净化，以创新科技赋能品质生活。',
          features: ['品质卓越', '型号齐全', '专业定制']
        };
        this.banner.features = JSON.parse(this.banner.features);
        // 处理产品系列和推荐案例标题
        const sections = responses[3].list.reduce((acc, item) => {
          acc[item.section_key] = item;
          return acc;
        }, {});
        this.series = sections.series || {
          title: '我们的产品系列',
          subtitle: '涵盖家用、商用及工业用等多个领域，品类齐全'
        };
        this.cases = sections.cases || {
          title: '推荐案例',
          subtitle: '我们的产品已成功应用于众多知名项目，获得了客户的一致好评'
        };
      } catch (error) {
        console.error('获取产品页面数据失败:', error);
      }
    }
  }
};
</script>

<style scoped>
/* 样式保持不变 */
.Pt75 {
  padding-top: 75px;
  padding-bottom: 75px;
}
.BgGray {
  background-color: #f8f9fa;
}
.box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}
.center {
  text-align: center;
}
.PubTitle h2 {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}
.PubTitle p {
  font-size: 18px;
  color: #666;
  max-width: 800px;
  margin: 0 auto 50px;
  line-height: 1.7;
}

/* 产品页面横幅 */
.product-banner {
  background: #47975a;
  color: white;
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}
.banner-content h1 {
  font-size: 56px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
.banner-content > p {
  font-size: 24px;
  opacity: 0.95;
  margin-bottom: 40px;
}
.banner-features {
  display: flex;
  justify-content: center;
  gap: 30px;
}
.banner-features span {
  background: rgba(255, 255, 255, 0.2);
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* 产品网格样式 */
.product-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
}
.product-grid > * {
  flex: 0 0 calc(33.333% - 27px); /* 减去gap的空间 */
}
.product-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

/* 卡片图片样式 */
.card-image {
  position: relative;
  height: 300px;
  overflow: hidden;
}
.card-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
  background-color: #f8f9fa;
  transition: transform 0.3s ease;
}
.product-card:hover .card-image img {
  transform: scale(1.05);
}
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.product-card:hover .image-overlay {
  opacity: 1;
}
.details-link {
  color: #fff;
  background-color: rgba(71, 151, 90, 0.8);
  padding: 12px 24px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
}
.details-link:hover {
  background-color: #47975a;
}

/* 卡片内容样式 */
.card-content {
  padding: 25px 30px;
  text-align: center;
  flex-grow: 1;
}
.card-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #47975a;
  margin-bottom: 20px;
}
.subcategory-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.subcategory-list li {
  background-color: #f0f8f4;
  color: #47975a;
  padding: 6px 15px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 500;
}

/* 推荐案例样式 */
.cases-list {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px 40px;
}
.case-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}
.case-item:hover {
  transform: translateX(5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  border-left: 3px solid #47975a;
}
.case-title {
  font-size: 16px;
  color: #333;
  text-decoration: none;
  flex-grow: 1;
  margin-right: 20px;
}
.case-title:hover {
  color: #47975a;
}
.case-title .dot {
  color: #47975a;
  margin-right: 8px;
  font-weight: bold;
}
.case-date {
  font-size: 16px;
  color: #888;
  font-weight: 500;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .Pt75 {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .banner-content h1 {
    font-size: 36px;
  }
  .banner-content > p {
    font-size: 18px;
  }
  .PubTitle h2 {
    font-size: 28px;
  }
  .PubTitle p {
    font-size: 16px;
    margin-bottom: 40px;
  }
  .cases-list {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .product-grid > * {
    flex: 0 0 calc(100% - 7px); /* 减去gap的空间 */
  }
  .case-item {
    flex-direction: row !important;
  }
  .ProductPage .product-banner .banner-features {
    flex-direction: row !important;
  }
}

@media (max-width: 480px) {
  .banner-features {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  .card-content {
    padding: 20px;
  }
  .card-content h3 {
    font-size: 20px;
  }
  .subcategory-list li {
    font-size: 13px;
    padding: 5px 12px;
  }
  .case-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
}
</style>